import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';
import queryString from 'query-string';

import {refresh as paginatorRefresh, clearSelection} from '../../paginator/actions';
import {request} from '../../containers/actions';
import PaginatedContainer from '../../paginator/paginated_container';


export default class Compilers extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: item => `${item.firstname} ${item.lastname}`, label: window.gettext('Name')},
        {field: 'national_id', label: window.gettext('National ID')},
    ]

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'national_id', label: window.gettext('national id')},
        {name: 'firstname', label: window.gettext('firstname')},
        {name: 'lastname', label: window.gettext('lastname')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                            label: window.gettext('Remove'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna remove these %(count)s compiler?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/compiler/?' + queryString.stringify({
                                        id: this.props.store.getIn(['paginator', 'selected']).keySeq().join(','),
                                    }),
                                    method: 'DELETE',
                                }));
                                this.context.store.dispatch(clearSelection(this.props.store.getIn(['paginator', 'elementId'])));
                            },
                        },
                        {
                            label: window.gettext('Mass Edit'),
                            action: () => this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + this.props.store.getIn(['paginator', 'selected']).keySeq().join(',') + '/',
                            )),
                        },
                    ]
                    : [],
            )
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
            () => this.props.readonly,
        ],
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New Compiler'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'add/',
                    )),
                },
            ])
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='compiler'
            title={window.gettext('Compilers')}
            listFields={this.listFields}
            selectable
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            actions={this.actionsSelector(this.props.store)}
            buttonActions={this.buttonActionsSelector(this.props.store)}
        />;
    }
}
